import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import styles from './index.styl';

const ResendButton = ({
  intl,
  onResend,
  counterValue = 30,
  customCounterText = '',
}) => {
  const [counter, setCounter] = useState(0);
  const { formatMessage } = intl;

  const handleResend = () => {
    onResend();
    setCounter(counterValue);
  };

  const counterText = useMemo(() => {
    if (counter === 0) {
      return (
        <div onClick={handleResend} className={styles.resend}>
          {formatMessage({ id: 'common.resendCode' })}
        </div>
      );
    }

    if (customCounterText) {
      return <div>{formatMessage({ id: customCounterText }, { counter })}</div>;
    }

    return (
      <div>{formatMessage({ id: 'mfa.dialog.resendCode' }, { counter })}</div>
    );
  }, [counter, customCounterText]);

  useEffect(() => {
    let timer = null;
    if (counter > 0) {
      timer = setTimeout(() => setCounter(counter - 1), 1000);
    }

    return () => clearTimeout(timer);
  }, [counter]);

  return <div className={styles.wrapper}>{counterText}</div>;
};

ResendButton.propTypes = {
  counterValue: PropTypes.number,
  customCounterText: PropTypes.string,
  intl: PropTypes.object,
  onResend: PropTypes.func,
};

export default injectIntl(ResendButton);



// WEBPACK FOOTER //
// ./src/components/MfaDialog/ResendButton/ResendButton.jsx